import { useToggle } from "@react-hookz/web";
import type { FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";
import { FollowButtonDisplay, FollowButtonVariant, FollowType } from "scmp-sdk";

import { AuthorAvatar } from "scmp-app/components/author/author-avatar";
import type { defaultAuthorCardAuthor$key } from "scmp-app/queries/__generated__/defaultAuthorCardAuthor.graphql";

import {
  AuthorCardContainer,
  AvatarContainer,
  BioContainer,
  HeaderContainer,
  StyledAuthorBio,
  StyledAuthorName,
  StyledHomeFollowButton,
} from "./styles";

export type Props = {
  reference: defaultAuthorCardAuthor$key;
  variant?: "generic";
};

export const DefaultAuthorCard: FunctionComponent<Props> = ({ reference: reference_, variant }) => {
  const author = useFragment(
    graphql`
      fragment defaultAuthorCardAuthor on Author {
        ...authorAvatarAuthor
        ...authorBioAuthor
        ...authorNameAuthor
        ...authorRoleAuthor
        ...entityFollowButtonBase
        ...followButtonBase
      }
    `,
    reference_,
  );

  const [isExpandBio, setIsExpandBio] = useToggle();

  const getHomeFollowButtonVariantProps = () => {
    if (variant === "generic") {
      return {
        buttonVariant: "get-alert" as const,
        display: FollowButtonDisplay.DarkBluePlusIcon,
        variant: FollowButtonVariant.GetAlert,
      };
    }

    return {};
  };

  return (
    <AuthorCardContainer>
      <AvatarContainer>
        <AuthorAvatar height={300} placeholder reference={author} width={300} />
      </AvatarContainer>
      <HeaderContainer>
        <StyledAuthorName reference={author} />
        <StyledHomeFollowButton
          isLoadingEnabled
          reference={author}
          source="Article_bottom"
          type={FollowType.Author}
          {...getHomeFollowButtonVariantProps()}
        />
      </HeaderContainer>
      <BioContainer>
        <StyledAuthorBio $isExpand={isExpandBio} onClick={setIsExpandBio} reference={author} />
      </BioContainer>
    </AuthorCardContainer>
  );
};

DefaultAuthorCard.displayName = "DefaultAuthorCard";
